module.exports = __webpack_public_path__ + "static/media/30OIOS2.d21f5e89.jpg";